import { render, staticRenderFns } from "./BreadcrumbsComponent.vue?vue&type=template&id=537e3509&scoped=true&"
import script from "./BreadcrumbsComponent.vue?vue&type=script&lang=ts&"
export * from "./BreadcrumbsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537e3509",
  null
  
)

export default component.exports